import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import { siteTitle } from '../../../../data/SiteConfig';
import {
  overflow,
  content,
  text_overflow,
  text_width,
  header_content
} from './PdView.module.css';
import { getPD, getCustomerDetails } from '../../../common/constants/api';
import PopUp from '../../../common/components/PopUp/PopUp';
import moment from 'moment';
import { navigate } from 'gatsby';
import backBtn_icon from '../../../images/icons/backBtn_icon.svg';
import { numberFormat } from '../../../common/constants/NumberFormat';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import MakeACall from '../../../components/MakeACall/MakeACall';

const PDViewOnly = props => {
  const [show, setShow] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [pdData, setPdData] = useState([]);
  const [applicantData, setApplicantData] = useState({});
  const [propertyCity, setPropertyCity] = useState();
  const [basicInfo, setBasicInfo] = useState(getApplicantionInfo().leadData);

  useEffect(() => {
    setShow(true);
    setType('loading');
    setText('Getting PD details please wait...');
    getPD(basicInfo.leadId)
      .then(res => {
        if (res.error) throw new Error(res);
        setPdData(res);
        setShow(false);
      })
      .catch(error => {
        setShow(false);
      });
  }, []);

  const Content = ({ name, value, isNumberFormat = false, valueClass }) => {
    return (
      <div className={`flex items-center my-2 lg:my-0 ${content}`}>
        <p
          className={`text-grey-2232 font-normal text-sm text-left lg:text-right pr-2 w-full whitespace-no-wrap  `}
        >
          {name}
        </p>
        <p
          className={`text-black-500  text-sm text-left w-full whitespace-no-wrap ${valueClass}  `}
        >
          :
          {name == 'Mobile' && (
            <div className="w-full ml-1">
              <MakeACall
                phoneNumber={applicantData?.phone}
                leadId={basicInfo?.leadId}
                applicantId={basicInfo?.leadMainApplicantId}
                phoneCallStyles={{
                  height: '18px',
                  width: '18px',
                  color: 'rgb(56 169 56)'
                }}
                spinnerStyles={{ height: '18px', width: '18px' }}
              />
            </div>
          )}
          {name != 'Mobile' &&
            (isNumberFormat ? (
              <span className="font-medium">
                &#8377; {numberFormat(value || 0)}
              </span>
            ) : (
              <span className="font-medium"> {value}</span>
            ))}
        </p>
      </div>
    );
  };

  const CommonHeader = ({ name }) => (
    <h2 className="w-full text-left text-base font-roboto text-black-1013 font-medium my-3">
      {name}
    </h2>
  );

  const CommonSmallHeader = ({ name }) => (
    <h2
      className="w-full text-left  font-roboto text-grey-1005 font-medium my-3 text-sm"
      style={{ fontSize: '0.9rem' }}
    >
      {name}
    </h2>
  );

  const CommonBody = ({ name, value, isNuberFormat = false }) => {
    let displayValue = value ? value?.toString()?.replace(/_/g, ' ') : '---';
    return (
      <div className="flex my-2 ">
        <p
          className={`text-black-1014 font-normal text-sm text-left pr-2 ${text_overflow} ${text_width}`}
        >
          {name}
        </p>
        <p
          className={`text-black-1014  text-sm text-left  break-words mr-2   ${text_overflow} ${text_width}`}
        >
          :
          {isNuberFormat ? (
            <span className="font-medium capitalize ml-1">
              &#8377;{numberFormat(value ? value : 0)}
            </span>
          ) : (
            <span className="font-medium capitalize ml-1"> {displayValue}</span>
          )}
        </p>
      </div>
    );
  };

  const CommonCommentSection = ({ data }) => (
    <div className="table mt-2">
      <div className="w-full flex">
        <span
          className="bg-grey-1005 rounded-full  text-white text-sm font-roboto font-normal text-center items-center"
          style={{ width: '30px', height: '30px', paddingTop: '5px' }}
        >
          {data?.name?.toString().charAt(0)}
        </span>
        <p className="text-grey-1005 rounded-full  text-sm font-roboto font-normal text-left ml-2 items-center mt-1 ">
          {data.comment}
        </p>
      </div>
      <div className="w-full flex">
        <p className="text-grey-1005 rounded-full  text-xs font-roboto font-normal text-left ml-9 mr-3">
          {data.name}
        </p>
        <p className="text-grey-1005 rounded-full  text-xs font-roboto font-normal ml-auto text-left  ">
          {moment(data.createdAt).format('Do MMM hh:mm A')}
        </p>
      </div>
    </div>
  );
  useEffect(() => {
    setShow(true);
    setType('loading');
    setText('Getting PD details please wait...');
    getCustomerDetails(getApplicantionInfo().leadId)
      .then(res => {
        if (res.error) throw new Error(res);
        setApplicantData(res);
        setShow(false);
      })
      .catch(error => {
        setShow(false);
      });
  }, []);
  useEffect(() => {
    setPropertyCity(getApplicantionInfo().leadData?.propertyCity);
  }, []);
  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="widhtMd max-screen flex-1  w-full ">
            <Header />
            <div className="w-full px-3 my-4">
              <div className="bg-white rounded py-3">
                <span
                  onClick={() =>
                    props.redirect == 'leadprofile'
                      ? navigate('/app/leadprofile')
                      : navigate('/app/dashboard?type=leads')
                  }
                  className="inline-flex items-center cursor-pointer relative ml-2"
                >
                  <img src={backBtn_icon} alt="" />
                  <span className="pl-3 text-black-1015 text-base">
                    Go Back
                  </span>
                </span>

                <h1 className="font-roboto font-medium text-center text-black-400 w-full text-xl mb-4">
                  Personal Discussion Form
                </h1>
                <div className="w-full px-3">
                  <div
                    className={`w-12/12 xl:w-11/12  lg:flex bg-grey-997 rounded  mx-auto px-5 py-4 items-center overflow-auto ${overflow} ${header_content}`}
                  >
                    <Content
                      name="Name"
                      value={`${
                        applicantData?.name?.firstName
                          ? applicantData.name.firstName
                          : ''
                      } ${
                        applicantData?.name?.lastName
                          ? applicantData.name.lastName
                          : ''
                      } `}
                      paraSpecialClass="lg:w-5/12"
                      valueSpecialClass="lg:w-full"
                    />
                    <Content
                      name="Lead ID"
                      value={applicantData?.id}
                      paraSpecialClass="lg:w-6/12"
                      valueSpecialClass="lg:w-full"
                    />
                    <Content
                      name="Mobile"
                      value={`+91 - ${applicantData?.phone}`}
                      paraSpecialClass="lg:w-5/12"
                      valueSpecialClass="lg:w-full"
                      valueClass="flex items-center"
                    />
                    <Content
                      name="City"
                      value={propertyCity || '---'}
                      paraSpecialClass="lg:w-4/12"
                      valueSpecialClass="w-full"
                    />
                    <Content
                      name="Loan Type"
                      value={applicantData?.productName || '---'}
                      paraSpecialClass="lg:w-6/12"
                      valueSpecialClass="lg:w-6/12"
                    />
                    <Content
                      name="Loan Amount"
                      value={applicantData?.loanAmount || '---'}
                      paraSpecialClass="lg:w-7/12"
                      valueSpecialClass="lg:w-5/12"
                      isNumberFormat={true}
                    />
                  </div>
                </div>
                <div className="w-full my-5 px-6 ">
                  <div className="w-full xl:w-6/12">
                    <div className="w-12/12 mr-auto ">
                      <CommonHeader name="Loan Details" />
                    </div>
                    <div className="w-full mr-auto  flex flex-wrap">
                      <CommonBody
                        name="Product Type"
                        value={pdData.productDetail?.displayName}
                      />
                      {pdData.productId == '2' ? (
                        <React.Fragment>
                          <CommonBody
                            name="BT Amount"
                            value={pdData?.btDetails?.btAmount}
                            isNuberFormat={true}
                          />
                          <CommonBody
                            name="BT Interest(%)"
                            value={pdData?.btDetails?.btInterest}
                          />
                          <CommonBody
                            name="BT Bank"
                            value={pdData?.btDetails?.btBankName}
                          />
                        </React.Fragment>
                      ) : null}
                    </div>
                  </div>

                  <hr className="border border-grey-200 my-5" />

                  <div className="w-full xl:w-12/12">
                    <div className="w-12/12 mr-auto ">
                      <CommonHeader name="Income Details" />
                    </div>
                    <div className="w-full mr-auto  block  ">
                      <div className="w-full mr-auto  flex flex-wrap  ">
                        <CommonBody
                          name="Profession Type"
                          value={pdData?.incomeDetails?.professionType}
                        />
                        <CommonBody
                          name="Employer Name"
                          value={pdData?.incomeDetails?.employerName}
                        />
                      </div>

                      <div className="w-full mr-auto  flex flex-wrap  ">
                        <CommonBody
                          name="Experience (years)"
                          value={pdData?.incomeDetails?.experienceInYears}
                        />
                        <CommonBody
                          name="ITR Filed"
                          value={
                            pdData?.incomeDetails?.itrFiled == true
                              ? 'Yes'
                              : 'No'
                          }
                        />
                      </div>

                      <div className="w-full mr-auto  flex flex-wrap  ">
                        <CommonBody
                          name="Monthly Income"
                          value={pdData?.incomeDetails?.monthlyIncome}
                          isNuberFormat={true}
                        />
                        <CommonBody
                          name="Any Rental Income?"
                          value={
                            pdData?.incomeDetails?.anyRentalIncome == true
                              ? 'Yes'
                              : 'No'
                          }
                        />
                      </div>
                      <div className="w-full mr-auto  flex flex-wrap  ">
                        <CommonBody
                          name="Amount of Rental Inocme"
                          value={pdData?.incomeDetails?.amountOfRentalIncome}
                          isNuberFormat={true}
                        />
                        <CommonBody
                          name="Type of Rental Income"
                          value={pdData?.incomeDetails?.typeOfRentalIncome}
                        />
                      </div>
                      <CommonBody
                        name="Percentage of Cheque (%)"
                        value={pdData?.incomeDetails?.percentageOfCheque}
                      />
                    </div>
                  </div>
                  <hr className="border border-grey-200 my-5" />

                  <div className="w-full">
                    <div className="w-12/12 mr-auto ">
                      <CommonHeader name="Property Details" />
                    </div>
                    <div className="w-full block">
                      <div className="w-full  flex flex-wrap  ">
                        <CommonBody
                          name="Property Type"
                          value={pdData?.leadPDPropertyDetails?.propertyType}
                        />
                        <CommonBody
                          name="Property Title"
                          value={
                            pdData?.leadPDPropertyDetails?.propertyTitleDetail
                              ?.name
                          }
                        />
                      </div>
                      <div className="w-full mr-auto  flex flex-wrap  ">
                        <CommonBody
                          name="Pincode"
                          value={pdData?.leadPDPropertyDetails?.pincode}
                        />
                        <CommonBody
                          name="Property Value"
                          value={pdData?.leadPDPropertyDetails?.propertyValue}
                          isNuberFormat={true}
                        />
                      </div>
                    </div>
                  </div>
                  <hr className="border border-grey-200 my-5" />
                  <div className="w-full">
                    <div className="w-12/12 mr-auto ">
                      <CommonHeader name="Co-Applicants Details" />
                    </div>

                    {typeof pdData?.listOfApplicantDetails == 'object'
                      ? pdData?.listOfApplicantDetails.map((each, index) => (
                          <div className="w-full">
                            <div className="w-full">
                              <CommonSmallHeader
                                name={`Co-Applicant-${index + 1}`}
                              />
                            </div>
                            <div className="w-full mr-auto  flex flex-wrap">
                              <CommonBody
                                name="Profession Type"
                                value={each.professionType}
                              />
                              <CommonBody
                                name="Monthly Income"
                                value={each.monthlyIncome}
                                isNuberFormat={true}
                              />
                            </div>
                          </div>
                        ))
                      : '---'}
                  </div>

                  <div className="w-full my-4">
                    <div className="w-full">
                      <CommonSmallHeader name="Comment" />
                    </div>
                    {typeof pdData?.listOfComments == 'object'
                      ? pdData?.listOfComments.map((each, index) => (
                          <div className="w-full">
                            <CommonCommentSection data={each} />
                          </div>
                        ))
                      : '---'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PopUp
        type={type}
        text={text}
        show={show}
        setShow={setShow}
        dontClose={true}
      />
    </React.Fragment>
  );
};

export default PDViewOnly;
